import { Link } from 'react-router-dom';
import '../styles/inner.css';
import '../styles/management.css';

const sideLinks = [
  { label: 'Management-Team', to: '/management-team', active: true  },
  { label: 'Our Peoples',     to: '/our-peoples',     active: false },
];

const members = [
  {
    name: 'Mr. Vinay Pal Jain',
    surname: 'JAIN',
    image: '/images/jain.gif',
    layout: 'text-left',
    bio: `Mr. Vinay Pal Jain- an entrepreneur with huge business empire and his 32 years of business experience consisting of diversified businesses like garments manufacturing, industrial chemicals trading, agro products trading, construction material trading, yarn mill and B.P.O. He has been able to succeed well in all the businesses with his great vision and tremendous entrepreneurial skills. His business acumen and financial worth contribute to sustained growth of the organization.`,
  },
  {
    name: 'Mr. VIKRAM',
    surname: 'GUPTA',
    image: '/images/vikram.gif',
    layout: 'text-right',
    bio: `Mr. Vikram Gupta- an entrepreneur with huge business empire and her 15 years of business experience consisting of diversified businesses like garments manufacturing, industrial chemicals trading, agro products trading, construction material trading, yarn mill and B.P.O. She has been able to succeed well in all the businesses with his great vision and tremendous entrepreneurial skills. he business acumen and financial worth contribute to sustained growth of the organization.`,
  },
];

export default function ManagementTeam() {
  return (
    <>
      {/* ── BANNER ── */}
      <div
        className="inner-banner"
        style={{ backgroundImage: "url('/images/ManagementsTeam-banner.jpg')" }}
      >
        <div className="container">
          <h1>Our Management-Team</h1>
          <div className="sep" />
          <h4>Matrix Processing House</h4>
        </div>
      </div>

      {/* ── CONTENT ── */}
      <div className="inner-bottom-sec">
        <div className="container">

          {/* SIDEBAR */}
          <div className="side-menu">
            <ul>
              {sideLinks.map((l, i) => (
                <li key={i} className={l.active ? 'active' : ''}>
                  <Link to={l.to}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* MAIN CONTENT */}
          <div className="inner-main-part">
            {members.map((m, i) => (
              <div
                key={i}
                className={`mgmt-member-bx ${m.layout === 'text-right' ? 'photo-left' : ''}`}
              >
                {/* TEXT SIDE */}
                <div className="mgmt-info">
                  <h2>
                    {m.name} <span>{m.surname}</span>
                  </h2>
                  <p>{m.bio}</p>
                </div>

                {/* PHOTO SIDE */}
                <div className="mgmt-photo">
                  <img src={m.image} alt={`${m.name} ${m.surname}`} />
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </>
  );
}
